module.exports = __webpack_public_path__ + "static/media/logo 1.b5b99719.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/img/logos/logo 1.png
// module id = 1488
// module chunks = 0